import React, { useState, useRef } from 'react'
import { message, Form, Avatar, Card, List, Row, Col, Button } from 'antd'
import ds from '../../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
import InfoToPrint from '../InfoToPrint'
import SearchCustomer from '../SearchCustomer'
import { StandardInvoice } from '../StandardInvoice'
import { useCookies } from 'react-cookie'
import { StandardThermalReceipt } from '../StandardThermalReceipt'
import {
  processCompleteSale,
  loadIsMainLoading,
  loadIsPaymentPanelLoading,
  loadIsSaleCompleted
} from '../../appRedux/actions/MainSale'
import IntlMessages from '../../util/IntlMessages'
import CustomScrollbars from '../../util/CustomScrollbars'
import { useReactToPrint } from 'react-to-print'
import {
  clearAllSale,
  notAllowMsgCheck,
  getDecryptID,
  isEmptyObject,
  formatDigits,
  customParse,
  parseFloatCustom,
  getSalesOrderID
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { getPrintStringForReceipt } from '../PrintString'
import axios from 'axios'
import { env } from '../../env'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from '../../appRedux/actions/IndexDBActions'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import moment from 'moment'
import { checkIsWeb } from '../../appRedux/actions/MobAppFn'

const {
  REACT_APP_LOCALIP_PRINT_HTTP,
  REACT_APP_PROXY_SERVER,
  TS_COOKIE_BASE_DOMAIN
} = env

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const expires_in = 18

const PaymentPanelActionComplete = props => {
  const {
    outletName,
    registerName,
    allowPrint,
    allowPrintNote,
    allowDiscountShow,
    allowNextUser
  } = props
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  // const componentThermalRef = useRef()
  // const componentInvoiceRef = useRef()
  // const handleThermalPrint = useReactToPrint({
  //   content: () => componentThermalRef.current
  // })
  // const handleInvoicePrint = useReactToPrint({
  //   content: () => componentInvoiceRef.current
  // })
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const [isDisable, setDisable] = React.useState(false)
  const [cookies, setCookie, removeCookie] = useCookies([
    'printHTML',
    'ip',
    'port'
  ])
  const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getAmountDiff = useSelector(({ MainSale }) => MainSale.getAmountDiff)
  const getCustomerAccountDetails = useSelector(
    ({ MainSale }) => MainSale.getCustomerAccountDetails
  )
  const getDataToPrint = useSelector(({ MainSale }) => MainSale.getDataToPrint)
  const getReduxTemplatedData = useSelector(
    ({ Setup }) => Setup.receiptTemplatesData
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getEarnedLoyalty = useSelector(
    ({ MainSale }) => MainSale.getEarnedLoyalty
  )
  const getAccLaybyCreditAmount = useSelector(
    ({ MainSale }) => MainSale.getAccLaybyCreditAmount
  )
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)

  const [getTemplateData, setTemplateData] = React.useState({})
  // const [getCurrentSalesOrderStatusID, setCurrentSalesOrderStatusID] =
  //   React.useState("12&&_9efa-1ea9-4faf-88ed-a48e65b46643"); //Default Status set to Progress

  const onFinish = values => {
    // setIsMainLoading(true);
    dispatch(loadIsMainLoading(true))
  }
  const onFinishFailed = errorInfo => {}

  // function printReceiptTemplate (isDefault) {
  //   if (isDefault && allowPrint) {
  //     const storedData =
  //       getReduxTemplatedData && getReduxTemplatedData.length > 0
  //         ? getReduxTemplatedData.filter(e => e.isDefault == true)
  //         : []
  //     const defaultData = storedData.length > 0 ? storedData[0] : {}
  //     setTemplateData(defaultData)
  //     if (defaultData && defaultData.templateStyleID == 1) {
  //       // handleThermalPrint();
  //       setTimeout(() => {
  //         handleThermalPrint()
  //       }, 1000) //small fraction of delay to load data
  //     } else {
  //       setTimeout(() => {
  //         handleInvoicePrint()
  //       }, 1000)
  //     }
  //   }
  // }

  // function onPrintConfig () {
  //   const localIpPort = localStorage.getItem('printConfig')
  //     ? JSON.parse(localStorage.getItem('printConfig'))
  //     : false
  //   let ip = false
  //   let port = false
  //   let receiptID = false
  //   let tempData = false
  //   if (localIpPort) {
  //     ip = localIpPort.ip ? localIpPort.ip : false
  //     port = localIpPort.port ? localIpPort.port : false
  //     receiptID = localIpPort.receiptID ? localIpPort.receiptID : false
  //     if (receiptID) {
  //       let fdata =
  //         getReduxTemplatedData &&
  //         getReduxTemplatedData.length > 0 &&
  //         getReduxTemplatedData.filter(
  //           e => receiptID == getDecryptID(e.templateID)
  //         ).length > 0
  //           ? getReduxTemplatedData.filter(
  //               e => receiptID == getDecryptID(e.templateID)
  //             )[0]
  //           : false

  //       if (fdata) tempData = fdata
  //     }
  //     if (!tempData) {
  //       tempData =
  //         getReduxTemplatedData &&
  //         getReduxTemplatedData.length > 0 &&
  //         getReduxTemplatedData.filter(e => e.isDefault == true).length > 0
  //           ? getReduxTemplatedData.filter(e => e.isDefault == true)[0]
  //           : {}
  //     }
  //   }
  //   if (ip) {
  //     let expires = new Date()
  //     expires.setTime(expires.getTime() + expires_in * 1000)
  //     let dataPrint = getDataToPrint
  //     dataPrint.outletName = outletName
  //     dataPrint.mainRegister = registerName

  //     const recieptHTML = TabSaleString(
  //       dataPrint,
  //       getCurrData ? getCurrData.currencyCode : '',
  //       2,
  //       tempData, // templateData,
  //       allowPrintNote,
  //       allowDiscountShow,
  //       ip,
  //       port
  //     )
  //   }
  // }

  // function onPrintConfig () {
  //   const localIpPort = localStorage.getItem('printConfig')
  //     ? JSON.parse(localStorage.getItem('printConfig'))
  //     : false
  //   let ip = false
  //   let port = false
  //   let hheader = ''
  //   let ffooter = ''
  //   let subtitle1 = ''
  //   let subtitle2 = ''
  //   let showDate = false
  //   let showOutlet = false
  //   let showRegister = false
  //   let showServedBy = false
  //   if (localIpPort) {
  //     ip = localIpPort.ip ? localIpPort.ip : false
  //     port = localIpPort.port ? localIpPort.port : false
  //     hheader = localIpPort.header ? localIpPort.header : ''
  //     ffooter = localIpPort.footer ? localIpPort.footer : ''
  //     subtitle1 = localIpPort.subtitle1 ? localIpPort.subtitle1 : false
  //     subtitle2 = localIpPort.subtitle2 ? localIpPort.subtitle2 : false
  //     showDate = localIpPort.showDatetime ? true : false
  //     showOutlet = localIpPort.showOutlet ? true : false
  //     showRegister = localIpPort.showRegister ? true : false
  //     showServedBy = localIpPort.showServedBy ? true : false
  //   }
  //   if (ip && port) {
  //     let expires = new Date()
  //     expires.setTime(expires.getTime() + expires_in * 1000)
  //     let dataPrint = getDataToPrint
  //     dataPrint.outletName = outletName
  //     dataPrint.mainRegister = registerName
  //     dataPrint.hheader = hheader
  //     dataPrint.ffooter = ffooter
  //     dataPrint.subtitle1 = subtitle1
  //     dataPrint.subtitle2 = subtitle2
  //     dataPrint.showDate = showDate
  //     dataPrint.showOutlet = showOutlet
  //     dataPrint.showRegister = showRegister
  //     dataPrint.showServedBy = showServedBy

  //     const recieptHTML = getPrintStringForReceipt(
  //       dataPrint,
  //       getCurrData ? getCurrData.currencyCode : '',
  //       2
  //     )

  //     setCookie('ip', ip, {
  //       domain: TS_COOKIE_BASE_DOMAIN,
  //       path: '/',
  //       expires
  //     })
  //     setCookie('port', port, {
  //       domain: TS_COOKIE_BASE_DOMAIN,
  //       path: '/',
  //       expires
  //     })
  //     const excryptHTML = window.btoa(unescape(encodeURIComponent(recieptHTML))) // btoa(recieptHTML)
  //     setCookie('printHTML', excryptHTML, {
  //       domain: TS_COOKIE_BASE_DOMAIN,
  //       path: '/'
  //       // ,expires
  //     })

  //     window.open(REACT_APP_PROXY_SERVER) // REACT_APP_PROXY_SERVER
  //   }

  //   // const localIpPort = localStorage.getItem('printConfig')
  //   //   ? JSON.parse(localStorage.getItem('printConfig'))
  //   //   : false
  //   // let ip = false
  //   // let port = false
  //   // if (localIpPort) {
  //   //   ip = localIpPort.ip ? localIpPort.ip : false
  //   //   port = localIpPort.port ? localIpPort.port : false
  //   // }
  //   // if (ip && port) {
  //   //   const receipt = getPrintStringForReceipt(getDataToPrint)
  //   //   // const config = {
  //   //   //   headers: { 'Content-Type': 'text/html' }
  //   //   // }
  //   //   var url = `${REACT_APP_LOCALIP_PRINT_HTTP}://${ip}:${port}`
  //   //   const instance = axios.create({
  //   //     baseURL: url
  //   //     // headers: {
  //   //     //   'Content-Type': 'text/html'
  //   //     // }
  //   //   })

  //   //   instance
  //   //     .post(url, receipt)
  //   //     .then(response => {
  //   //       // alert('yoho, successsss...!')
  //   //     })
  //   //     .catch(e => {
  //   //       // alert('FAILED, caught in catch')
  //   //     })
  //   // } else {
  //   //   alert('kindly provide ip and port')
  //   // }
  // }

  const handleSaleCompletePanelActive = () => {
    setDisable(true)
    processCompleteSale(
      sellActionLog,
      getCurrentSalesOrderStatusID,
      getAccLaybyCreditAmount,
      getSelectedOutlet,
      getSavings,
      getSaleOrderJson,
      isOnline,
      allowPrint,
      form,
      dispatch
    )
  }

  const changeValue =
    getSaleOrderJson && getSaleOrderJson.Change != undefined
      ? formatDigits(getSaleOrderJson.Change, getDefaultDecimalPlaces)
      : 0

  return (
    <>
      <div className='dk-card payment-panel--action'>
        <CustomScrollbars className='gx-module-content-scroll payment-area-content'>
          <div className='payment-panel-content--action payment-panel-content'>
            <div className='custom-text-center'>
              <h2 className='custom-font-size--48 mt-4'>
                {changeValue > 0 ? (
                  <>
                    <IntlMessages id='sell.sell.give' />{' '}
                    {getCurrData.currencyCode != null
                      ? getCurrData.currencyCode
                      : getCurrData.currencyName != null
                      ? getCurrData.currencyName
                      : getCurrData.currencySymbol}{' '}
                    {changeValue} <IntlMessages id='sell.sell.change' />{' '}
                  </>
                ) : (
                  <>
                    {getCurrentSalesOrderStatusID &&
                    getDecryptID(getCurrentSalesOrderStatusID) == '1' ? (
                      <IntlMessages id='mainsale.sell.layby' />
                    ) : getCurrentSalesOrderStatusID &&
                      getDecryptID(getCurrentSalesOrderStatusID) == '2' ? (
                      <IntlMessages id='mainsale.sell.acc' />
                    ) : (getCurrentSalesOrderStatusID &&
                        getDecryptID(getCurrentSalesOrderStatusID) == '13') ||
                      (getCurrentSalesOrderStatusID &&
                        getDecryptID(getCurrentSalesOrderStatusID) == '15') ? (
                      <IntlMessages id='mainsale.sell.refundcomplete' />
                    ) : getCurrentSalesOrderStatusID &&
                      getDecryptID(getCurrentSalesOrderStatusID) == '16' ? (
                      <IntlMessages id='mainsale.sell.exchangecomplete' />
                    ) : (
                      <IntlMessages id='sell.sell.paymentrecieved' />
                    )}
                  </>
                )}
              </h2>{' '}
              {getEarnedLoyalty > 0 && (
                <h4>
                  {`${getCurrData.currencySymbol} ${formatDigits(
                    getEarnedLoyalty,
                    getDefaultDecimalPlaces
                  )} `}
                  <IntlMessages id='mainsale.sell.earnloy' />
                </h4>
              )}
              <InfoToPrint
                role='ReceiptTemplates'
                data={getDataToPrint}
                outletName={outletName}
                registerName={registerName}
                allowPrintNote={allowPrintNote}
                allowDiscountShow={allowDiscountShow}
              />
            </div>
            <div className='dk-mt20 dk-mb20'>
              <Form
                {...formItemLayout}
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  prefix: '86'
                }}
                // className=""
                scrollToFirstError
                id='SellForm'
                name='SellForm'
                className='custom-bg-white'
              >
                {/* We need to add Customer Component */}

                {getCustomerObj && getCustomerObj.customerCode ? (
                  <>
                    <Card
                      className='sell-account-card payment-boxes-card'
                      title={
                        <div className='gx-module-list-icon'>
                          <Row gutter={12}>
                            <Col>
                              <div className='gx'>
                                <Avatar
                                  style={{ fontWeight: 'bold' }}
                                  className={`gx-avatar gx-bg-${
                                    true == 'even' ? 'green' : 'blue'
                                  } gx-size-46 mr-10`}
                                >
                                  {getCustomerObj.letterName
                                    ? getCustomerObj.letterName
                                    : '00'}
                                </Avatar>
                              </div>
                            </Col>

                            <Col>
                              <div className='gx-module-list-content'>
                                <div className='gx-mail-user-des'>
                                  <span className='gx-sender-name'>
                                    {getCustomerObj.customerFirstName
                                      ? getCustomerObj.customerFirstName
                                      : '-Name-'}
                                    {getCustomerObj.customerLastName
                                      ? getCustomerObj.customerLastName
                                      : ' '}
                                  </span>

                                  <span className='gx-toolbar-separator'>
                                    &nbsp;
                                  </span>

                                  <span className='vd-flag sm:hidden'>
                                    {getCustomerObj.groupName
                                      ? getCustomerObj.groupName
                                      : 'All Customers'}
                                  </span>
                                </div>
                                <div className='gx-message'>
                                  <p className='gx-text-truncate'>
                                    {getCustomerObj.customerCode
                                      ? getCustomerObj.customerCode
                                      : '000-ABC'}
                                  </p>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      }
                    >
                      <List
                        className='payment-boxes'
                        grid={{ gutter: 8, column: 3 }}
                        dataSource={getCustomerAccountDetails}
                        renderItem={item => (
                          <List.Item>
                            <Card
                              className='custom-text-center dk-mgb-15'
                              title={item.AmountType}
                            >
                              <h1>{item.Amount}</h1>
                            </Card>
                          </List.Item>
                        )}
                      />
                    </Card>
                  </>
                ) : (
                  <>
                    <SearchCustomer screen='SellScreen' />
                  </>
                )}
              </Form>
            </div>
          </div>
        </CustomScrollbars>
        <div className='sale-action-bar cart-total-div'>
          <Button
            className='dk-btn-add complete-sell'
            type='primary'
            block
            onClick={e => handleSaleCompletePanelActive(false)}
            disabled={isDisable}
          >
            <div className='pay-action pay-action-label'>
              <IntlMessages id='sell.sell.completesale' />
            </div>
          </Button>
        </div>
      </div>
    </>
  )
}

export default PaymentPanelActionComplete
